import {useMutation} from "@tanstack/react-query";
import {setUserClaims} from "../services/ClaimService";

export function useSetUserClaims() {
    return useMutation({
        mutationFn: setUserClaims,
    });
}
